

export const HOME_PAGE = "/";

export const UPLOAD_PAGE = "/upload";

export const COMMUNITY_PAGE = "/community";

export const TIMELINE_PAGE = "/timeline";

export const PROFILE_PAGE = '/profile';